export default "__VITE_ASSET__fSrFOcKP__"